// Small helpers used across Brand OS pages.
import React from "react";

export function EmptyState({ title, description, testId }) {
  return (
    <div className="bo-empty" data-testid={testId || "empty-state"}>
      <div style={{ fontFamily: "var(--bo-serif)", fontSize: 20, color: "var(--bo-ink)", marginBottom: 6 }}>
        {title}
      </div>
      <div>{description}</div>
    </div>
  );
}

export function Pill({ children, testId, tone }) {
  const style = tone === "warn" ? { background: "#fdf5e6", color: "#8a5a0a" } :
                tone === "danger" ? { background: "#fee2d2", color: "#8a2b0a" } :
                tone === "success" ? { background: "#e6f4ea", color: "#1f6c3f" } :
                tone === "muted" ? { background: "var(--bo-panel-alt)", color: "var(--bo-muted)" } :
                undefined;
  return (
    <span className="bo-pill" style={style} data-testid={testId}>
      <span className="bo-pill-dot" style={tone === "warn" ? { background: "#c48411" } :
                                             tone === "danger" ? { background: "#b45309" } :
                                             tone === "success" ? { background: "#2f9b5e" } :
                                             tone === "muted" ? { background: "var(--bo-muted)" } : undefined} />
      {children}
    </span>
  );
}

export function ErrorBanner({ error, testId }) {
  if (!error) return null;
  return (
    <div className="bo-login-error" role="alert" data-testid={testId || "error-banner"}>
      {error}
    </div>
  );
}

export function LoadingCard({ label }) {
  return (
    <div className="bo-card" data-testid="loading-card" aria-busy="true">
      <div className="bo-eyebrow">Loading</div>
      <div style={{ color: "var(--bo-muted)" }}>{label || "Working…"}</div>
    </div>
  );
}

export function AUTHORITY_ORDER(a) {
  return { Canonical: 6, Approved: 5, Reference: 4, External: 3, Unverified: 2, Historical: 1 }[a] ?? 0;
}
